import { AddNewDeveloperModal } from "molecules/Modals/AddNewDeveloperModal";
import React from "react";

import MasterTemplateTable from "templates/Master/MasterTemplateTable";
import api from "utils/api";

const Developers = () => {
  return (
    <MasterTemplateTable
      actions={{
        get: async () => {
          try {
            const { data } = await api("/developers/get", {
              method: "get",
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
        create: async ({ name, locationId, priority }) => {
          try {
            const reqData = { name, locationId, priority };
            const { data } = await api("/developers/add", {
              method: "post",
              data: reqData,
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
        update: async (id, { name, locationId, priority }) => {
          try {
            const reqData = { name, locationId, priority };
            const { data } = await api(`/developers/update/${id}`, {
              method: "put",
              data: reqData,
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
        remove: async (id) => {
          try {
            const { data } = await api(`/developers/delete/${id}`, {
              method: "delete",
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
      }}
      pageHeading="Developers"
      addRecord="Add Developer"
      searchRecord="Search Developer"
      table={{
        tableHeader: [
          {
            name: "Name",
            containerProps: {
              fontSize: "1.4rem",
              fontWeight: "600",
            },
          },
          {
            name: "Location",
            containerProps: {
              fontSize: "1.4rem",
              fontWeight: "600",
            },
          },
          {
            name: "Actions",
            containerProps: {
              fontSize: "1.4rem",
              fontWeight: "600",
            },
          },
        ],
        tableRowDatas: [
          {
            render: (record) => <td>{record?.name}</td>,
          },
          {
            render: (record) => <td>{record?.locations?.name}</td>,
          },
        ],
        actions: { editable: true, removable: true },
      }}
      actionModal={{ title: "Developer", CustomModal: AddNewDeveloperModal }}
    />
  );
};

export default Developers;
